import { WidgetStore } from 'state/widgetStore';

export const widgetStore: { store: WidgetStore | null } = { store: null };
